<template>
    <div class="container-fluid" v-if="rastreador && posicao">

        <header-admin :rastreador="rastreador" :posicao="posicao" :veiculo="veiculo"></header-admin>

        <vue-tabs :keep-alive="true">

            <v-tab title="INICIAL">
                <br/>
                <positions-maps :posicao="posicao"/>
            </v-tab>

            <v-tab title="TRANSMISSAO" v-if="veiculo">
                <br/>
                <div class="rows">
                    <div class="col-sm-3">
                        <habilitar-alerta-transmissao class="btn-block" :veiculo="veiculo" @reload="loadVeiculo($event)"/>
                    </div>
                    <div class="col-sm-9 " style="margin-top: 5px">
                        ESTE ALERTA HABILITA QUE NOTIFIQUE CASO TENHA ALGUMA TRANSMISSÂO DO VEÍCULO
                    </div>
                </div>

            </v-tab>

            <v-tab title="OBS" v-if="veiculo">
                <br/>
                <label for="hora_inicial_noturno" class="col-sm-6 control-label">OBS DO VEÍCULO:</label>
                <textarea v-model="veiculo.obs" style="height: 200px !important;" class="form-control"></textarea>
            </v-tab>

            <v-tab title="DIREÇÃO NOTURNA" v-if="veiculo">
                <form-direcao-noturna :veiculo="veiculo"></form-direcao-noturna>
            </v-tab>

            <v-tab title="HISTÓRICO">
                <br/>
                <relatorio-periodo :id_rastreador="rastreador.id_rastreador"/>
            </v-tab>

            <v-tab title="ALERTAS" v-if="veiculo">
                <br/>
                <relatorio-alertas :uuid="veiculo.uuid"/>
            </v-tab>

            <v-tab title="RELATÓRIOS" v-if="veiculo">
                <br/>
                <relatorios :uuid="veiculo.uuid" :id_cliente="veiculo.id_cliente"></relatorios>
            </v-tab>

        </vue-tabs>

    </div>
    <div class="container-fluid" v-else>
        <center>
            <h1>Aguardando dados e primeira transmissão</h1>
        </center>
        <vue-tabs :keep-alive="true">

            <v-tab title="COMANDOS" v-if="rastreador">

                <br/>

                <div class="col-sm-3">
                    <enviar-saidas :enable_output2="false" :id_rastreador="rastreador.id_rastreador"/><br/>
                    <reset :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-configuracao :id_rastreador="rastreador.id_rastreador"/>
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </v-tab>
        </vue-tabs>
    </div>
</template>
<script>
    import SolicitarConfiguracao from '../../components/buttons/SolicitarConfiguracao.vue';
    import Tempos from './partials/concox/Tempos';
    import Apn from './partials/concox/Apn';
    import Ip from './partials/concox/Ip';
    import Filtro from './partials/concox/Filtro';
    import HeaderAdmin from './HeaderAdmin';
    import Relatorios from '../../components/veiculo/Relatorios';
    import RelatorioPeriodo from '../relatorios/RelatorioPeriodo';
    import FormDirecaoNoturna from '../forms/FormDirecaoNoturna';
    import EnviarSaidas from '../../components/buttons/EnviarSaidas';
    import HabilitarAlertaTransmissao from "../buttons/HabilitarAlertaTransmissao";
    import RelatorioAlertas from "../relatorios/RelatorioAlertas";
    import MapPosicao from "./partials/MapPosicao.vue";
    import PosicaoAtual from "./partials/PosicaoAtual.vue";
    import TableComandos from "../tables/TableComandos";
    import Reset from "../buttons/Reset";
    import GoogleMapsButton from "../buttons/GoogleMapsButton.vue";
    import GoogleEarthButton from "../buttons/GoogleEarthButton.vue";
    import PositionsMaps from './partials/PositionsMaps.vue';
    import {veiculosAdminMixins} from './partials/veiculo-admin-mixins';

    export default {
        name: 'Delta',

        components: {
            PositionsMaps,
            GoogleEarthButton,
            GoogleMapsButton,
            RelatorioAlertas,
            HabilitarAlertaTransmissao,
            EnviarSaidas,
            FormDirecaoNoturna, HeaderAdmin, Relatorios, RelatorioPeriodo,
            PosicaoAtual, MapPosicao, TableComandos, Reset,
            SolicitarConfiguracao, Tempos, Apn, Ip, Filtro
        },

        data(){
            return {
                config: null,
            }
        },

        mixins: [
            veiculosAdminMixins
        ],

        async beforeMount(){
            //this.config = await Concox.byPK(this.rastreador.id_rastreador);
        },
    }
</script>
